export const MetaData = {
  defaultTitle: 'WALDO Daily Contact Lenses',
  productTitle: 'Waldo Original | WALDO Daily Contact Lenses',
  title:
    ' Free Contact Lens Trial | High-Quality &amp; Maximum Comfort ✌️ | WALDO Daily Contact Lenses',
};
